import React from 'react';
import { IoCopyOutline } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';

const MealCard = ({ title, type, countries, meal, id }) => {
  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(id);
      toast.success('Copied to clipboard!');
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <Link
      to={`/meals/${id}`}
      className="block overflow-hidden bg-white rounded-2xl border border-gray-200 shadow-sm transition-all duration-300 group hover:shadow-xl hover:-translate-y-1 hover:border-gray-300"
      style={{ textDecoration: 'none' }}
    >
      {/* Image */}
      <div className="relative h-[200px] w-full overflow-hidden">
        {meal?.image ? (
          <img
            src={meal.image}
            alt={meal?.name}
            className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <div className="flex justify-center items-center w-full h-full text-gray-400 bg-gray-100">
            No Image
          </div>
        )}

        {/* Copy button floating over image, top-right */}
        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            copyToClipboard();
          }}
          className="flex absolute top-3 right-3 gap-1.5 items-center px-3 py-1.5 text-xs font-medium text-gray-700 rounded-full shadow-md backdrop-blur-sm transition-colors bg-white/90 hover:bg-white hover:text-gray-900"
        >
          Copy ID <IoCopyOutline className="text-sm" />
        </button>
      </div>

      {/* Content */}
      <div className="p-4">
        <p className="text-lg font-semibold leading-snug text-gray-900">{title}</p>

        <div className="flex flex-wrap gap-1.5 mt-2">
          {type.map((t, i) => (
            <span
              key={i}
              className="px-2.5 py-1 text-xs font-medium text-orange-700 bg-orange-50 rounded-full"
            >
              {t}
            </span>
          ))}
        </div>

        <div className="mt-3 text-sm text-gray-500">
          <span className="font-medium text-gray-700">Countries: </span>
          {countries.join(', ')}
        </div>

        <div className="flex justify-between items-center pt-3 mt-2 border-t border-gray-100">
          <span className="text-sm font-medium text-gray-700">Meal Tags</span>
          <span
            className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${
              meal?.tags?.length > 0
                ? 'bg-green-100 text-green-700'
                : 'bg-gray-100 text-gray-500'
            }`}
          >
            {meal?.tags?.length > 0 ? 'Yes' : 'No'}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default MealCard;
